import styled, { css } from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledReset,
    styledTypography,
} from '../styles';

export const PrimitiveInputText = styled.input`
    ${styledReset.input};
    ${styledTypography.allianceBase};

    &:disabled {
        cursor: not-allowed;
    }

    &:read-only {
        ${styledTypography.truncate};
    }

    &[type='search'] {
        ${styledReset.inputSearchSubset};
    }

    /* Change Autocomplete styles in Chrome*/
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus {
        -webkit-text-fill-color: #523df1 !important;
        transition: background-color 5000s ease-in-out 0s;
    }
`;

///
/// Recipes

const basic = css`
    outline: 2px solid transparent;
    outline-offset: 2px;
    transition-property: color, background-color, border-color, outline-color, opacity;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:focus-visible {
        outline-color: ${designColor.brandPurple};
    }
`;

export const recipesInputText = {
    basic,
};
